export const COUNTRIES = [
  { name: "India", iso: "IN", cc: "91" },
  { name: "Colombia", iso: "CO", cc: "57" },
  { name: "United States", iso: "US", cc: "1" },
  { name: "Canada", iso: "CA", cc: "1" },
  { name: "Afghanistan", iso: "AF", cc: "93" },
  { name: "Albania", iso: "AL", cc: "355" },
  { name: "Algeria", iso: "DZ", cc: "213" },
  { name: "American Samoa", iso: "AS", cc: "1684" },
  { name: "Andorra", iso: "AD", cc: "376" },
  { name: "Angola", iso: "AO", cc: "244" },
  { name: "Anguilla", iso: "AI", cc: "1264" },
  { name: "Antigua and Barbuda", iso: "AG", cc: "1268" },
  { name: "Argentina", iso: "AR", cc: "54" },
  { name: "Armenia", iso: "AM", cc: "374" },
  { name: "Aruba", iso: "AW", cc: "297" },
  { name: "Australia", iso: "AU", cc: "61" },
  { name: "Austria", iso: "AT", cc: "43" },
  { name: "Azerbaijan", iso: "AZ", cc: "994" },
  { name: "Bahamas", iso: "BS", cc: "1242" },
  { name: "Bahrain", iso: "BH", cc: "973" },
  { name: "Bangladesh", iso: "BD", cc: "880" },
  { name: "Barbados", iso: "BB", cc: "1246" },
  { name: "Belarus", iso: "BY", cc: "375" },
  { name: "Belgium", iso: "BE", cc: "32" },
  { name: "Belize", iso: "BZ", cc: "501" },
  { name: "Benin", iso: "BJ", cc: "229" },
  { name: "Bermuda", iso: "BM", cc: "1441" },
  { name: "Bhutan", iso: "BT", cc: "975" },
  { name: "Bolivia", iso: "BO", cc: "591" },
  { name: "Bosnia and Herzegovina", iso: "BA", cc: "387" },
  { name: "Botswana", iso: "BW", cc: "267" },
  { name: "Brazil", iso: "BR", cc: "55" },
  { name: "British Virgin Islands", iso: "VG", cc: "1284" },
  { name: "Brunei", iso: "BN", cc: "673" },
  { name: "Bulgaria", iso: "BG", cc: "359" },
  { name: "Burkina Faso", iso: "BF", cc: "226" },
  { name: "Burundi", iso: "BI", cc: "257" },
  { name: "Cambodia", iso: "KH", cc: "855" },
  { name: "Cameroon", iso: "CM", cc: "237" },
  { name: "Cape Verde", iso: "CV", cc: "238" },
  { name: "Cayman Islands", iso: "KY", cc: "1345" },
  { name: "Central African Republic", iso: "CF", cc: "236" },
  { name: "Chad", iso: "TD", cc: "235" },
  { name: "Chile", iso: "CL", cc: "56" },
  { name: "China", iso: "CN", cc: "86" },
  { name: "Comoros", iso: "KM", cc: "269" },
  { name: "Congo (DRC)", iso: "CD", cc: "243" },
  { name: "Congo (Republic)", iso: "CG", cc: "242" },
  { name: "Costa Rica", iso: "CR", cc: "506" },
  { name: "Croatia", iso: "HR", cc: "385" },
  { name: "Cuba", iso: "CU", cc: "53" },
  { name: "Cyprus", iso: "CY", cc: "357" },
  { name: "Czech Republic", iso: "CZ", cc: "420" },
  { name: "Denmark", iso: "DK", cc: "45" },
  { name: "Djibouti", iso: "DJ", cc: "253" },
  { name: "Dominica", iso: "DM", cc: "1767" },
  { name: "Dominican Republic", iso: "DO", cc: "1809" },
  { name: "Ecuador", iso: "EC", cc: "593" },
  { name: "Egypt", iso: "EG", cc: "20" },
  { name: "El Salvador", iso: "SV", cc: "503" },
  { name: "Equatorial Guinea", iso: "GQ", cc: "240" },
  { name: "Eritrea", iso: "ER", cc: "291" },
  { name: "Estonia", iso: "EE", cc: "372" },
  { name: "Eswatini", iso: "SZ", cc: "268" },
  { name: "Ethiopia", iso: "ET", cc: "251" },
  { name: "Falkland Islands", iso: "FK", cc: "500" },
  { name: "Faroe Islands", iso: "FO", cc: "298" },
  { name: "Fiji", iso: "FJ", cc: "679" },
  { name: "Finland", iso: "FI", cc: "358" },
  { name: "France", iso: "FR", cc: "33" },
  { name: "French Guiana", iso: "GF", cc: "594" },
  { name: "French Polynesia", iso: "PF", cc: "689" },
  { name: "Gabon", iso: "GA", cc: "241" },
  { name: "Gambia", iso: "GM", cc: "220" },
  { name: "Georgia", iso: "GE", cc: "995" },
  { name: "Germany", iso: "DE", cc: "49" },
  { name: "Ghana", iso: "GH", cc: "233" },
  { name: "Gibraltar", iso: "GI", cc: "350" },
  { name: "Greece", iso: "GR", cc: "30" },
  { name: "Greenland", iso: "GL", cc: "299" },
  { name: "Grenada", iso: "GD", cc: "1473" },
  { name: "Guadeloupe", iso: "GP", cc: "590" },
  { name: "Guam", iso: "GU", cc: "1671" },
  { name: "Guatemala", iso: "GT", cc: "502" },
  { name: "Guernsey", iso: "GG", cc: "44" },
  { name: "Guinea", iso: "GN", cc: "224" },
  { name: "Guinea-Bissau", iso: "GW", cc: "245" },
  { name: "Guyana", iso: "GY", cc: "592" },
  { name: "Haiti", iso: "HT", cc: "509" },
  { name: "Honduras", iso: "HN", cc: "504" },
  { name: "Hong Kong", iso: "HK", cc: "852" },
  { name: "Hungary", iso: "HU", cc: "36" },
  { name: "Iceland", iso: "IS", cc: "354" },
  { name: "Indonesia", iso: "ID", cc: "62" },
  { name: "Iran", iso: "IR", cc: "98" },
  { name: "Iraq", iso: "IQ", cc: "964" },
  { name: "Ireland", iso: "IE", cc: "353" },
  { name: "Isle of Man", iso: "IM", cc: "44" },
  { name: "Israel", iso: "IL", cc: "972" },
  { name: "Italy", iso: "IT", cc: "39" },
  { name: "Jamaica", iso: "JM", cc: "1876" },
  { name: "Japan", iso: "JP", cc: "81" },
  { name: "Jersey", iso: "JE", cc: "44" },
  { name: "Jordan", iso: "JO", cc: "962" },
  { name: "Kazakhstan", iso: "KZ", cc: "7" },
  { name: "Kenya", iso: "KE", cc: "254" },
  { name: "Kiribati", iso: "KI", cc: "686" },
  { name: "Kuwait", iso: "KW", cc: "965" },
  { name: "Kyrgyzstan", iso: "KG", cc: "996" },
  { name: "Laos", iso: "LA", cc: "856" },
  { name: "Latvia", iso: "LV", cc: "371" },
  { name: "Lebanon", iso: "LB", cc: "961" },
  { name: "Lesotho", iso: "LS", cc: "266" },
  { name: "Liberia", iso: "LR", cc: "231" },
  { name: "Libya", iso: "LY", cc: "218" },
  { name: "Liechtenstein", iso: "LI", cc: "423" },
  { name: "Lithuania", iso: "LT", cc: "370" },
  { name: "Luxembourg", iso: "LU", cc: "352" },
  { name: "Macau", iso: "MO", cc: "853" },
  { name: "Madagascar", iso: "MG", cc: "261" },
  { name: "Malawi", iso: "MW", cc: "265" },
  { name: "Malaysia", iso: "MY", cc: "60" },
  { name: "Maldives", iso: "MV", cc: "960" },
  { name: "Mali", iso: "ML", cc: "223" },
  { name: "Malta", iso: "MT", cc: "356" },
  { name: "Marshall Islands", iso: "MH", cc: "692" },
  { name: "Martinique", iso: "MQ", cc: "596" },
  { name: "Mauritania", iso: "MR", cc: "222" },
  { name: "Mauritius", iso: "MU", cc: "230" },
  { name: "Mexico", iso: "MX", cc: "52" },
  { name: "Micronesia", iso: "FM", cc: "691" },
  { name: "Moldova", iso: "MD", cc: "373" },
  { name: "Monaco", iso: "MC", cc: "377" },
  { name: "Mongolia", iso: "MN", cc: "976" },
  { name: "Montenegro", iso: "ME", cc: "382" },
  { name: "Montserrat", iso: "MS", cc: "1664" },
  { name: "Morocco", iso: "MA", cc: "212" },
  { name: "Mozambique", iso: "MZ", cc: "258" },
  { name: "Myanmar", iso: "MM", cc: "95" },
  { name: "Namibia", iso: "NA", cc: "264" },
  { name: "Nauru", iso: "NR", cc: "674" },
  { name: "Nepal", iso: "NP", cc: "977" },
  { name: "Netherlands", iso: "NL", cc: "31" },
  { name: "New Caledonia", iso: "NC", cc: "687" },
  { name: "New Zealand", iso: "NZ", cc: "64" },
  { name: "Nicaragua", iso: "NI", cc: "505" },
  { name: "Niger", iso: "NE", cc: "227" },
  { name: "Nigeria", iso: "NG", cc: "234" },
  { name: "North Macedonia", iso: "MK", cc: "389" },
  { name: "Northern Mariana Islands", iso: "MP", cc: "1670" },
  { name: "Norway", iso: "NO", cc: "47" },
  { name: "Oman", iso: "OM", cc: "968" },
  { name: "Pakistan", iso: "PK", cc: "92" },
  { name: "Palau", iso: "PW", cc: "680" },
  { name: "Palestine", iso: "PS", cc: "970" },
  { name: "Panama", iso: "PA", cc: "507" },
  { name: "Papua New Guinea", iso: "PG", cc: "675" },
  { name: "Paraguay", iso: "PY", cc: "595" },
  { name: "Peru", iso: "PE", cc: "51" },
  { name: "Philippines", iso: "PH", cc: "63" },
  { name: "Poland", iso: "PL", cc: "48" },
  { name: "Portugal", iso: "PT", cc: "351" },
  { name: "Puerto Rico", iso: "PR", cc: "1787" },
  { name: "Qatar", iso: "QA", cc: "974" },
  { name: "Réunion", iso: "RE", cc: "262" },
  { name: "Romania", iso: "RO", cc: "40" },
  { name: "Russia", iso: "RU", cc: "7" },
  { name: "Rwanda", iso: "RW", cc: "250" },
  { name: "Saint Kitts and Nevis", iso: "KN", cc: "1869" },
  { name: "Saint Lucia", iso: "LC", cc: "1758" },
  { name: "Saint Vincent and the Grenadines", iso: "VC", cc: "1784" },
  { name: "Samoa", iso: "WS", cc: "685" },
  { name: "San Marino", iso: "SM", cc: "378" },
  { name: "São Tomé and Príncipe", iso: "ST", cc: "239" },
  { name: "Saudi Arabia", iso: "SA", cc: "966" },
  { name: "Senegal", iso: "SN", cc: "221" },
  { name: "Serbia", iso: "RS", cc: "381" },
  { name: "Seychelles", iso: "SC", cc: "248" },
  { name: "Sierra Leone", iso: "SL", cc: "232" },
  { name: "Singapore", iso: "SG", cc: "65" },
  { name: "Slovakia", iso: "SK", cc: "421" },
  { name: "Slovenia", iso: "SI", cc: "386" },
  { name: "Solomon Islands", iso: "SB", cc: "677" },
  { name: "Somalia", iso: "SO", cc: "252" },
  { name: "South Africa", iso: "ZA", cc: "27" },
  { name: "South Korea", iso: "KR", cc: "82" },
  { name: "South Sudan", iso: "SS", cc: "211" },
  { name: "Spain", iso: "ES", cc: "34" },
  { name: "Sri Lanka", iso: "LK", cc: "94" },
  { name: "Sudan", iso: "SD", cc: "249" },
  { name: "Suriname", iso: "SR", cc: "597" },
  { name: "Sweden", iso: "SE", cc: "46" },
  { name: "Switzerland", iso: "CH", cc: "41" },
  { name: "Syria", iso: "SY", cc: "963" },
  { name: "Taiwan", iso: "TW", cc: "886" },
  { name: "Tajikistan", iso: "TJ", cc: "992" },
  { name: "Tanzania", iso: "TZ", cc: "255" },
  { name: "Thailand", iso: "TH", cc: "66" },
  { name: "Timor-Leste", iso: "TL", cc: "670" },
  { name: "Togo", iso: "TG", cc: "228" },
  { name: "Tonga", iso: "TO", cc: "676" },
  { name: "Trinidad and Tobago", iso: "TT", cc: "1868" },
  { name: "Tunisia", iso: "TN", cc: "216" },
  { name: "Turkey", iso: "TR", cc: "90" },
  { name: "Turkmenistan", iso: "TM", cc: "993" },
  { name: "Turks and Caicos Islands", iso: "TC", cc: "1649" },
  { name: "Tuvalu", iso: "TV", cc: "688" },
  { name: "Uganda", iso: "UG", cc: "256" },
  { name: "Ukraine", iso: "UA", cc: "380" },
  { name: "United Arab Emirates", iso: "AE", cc: "971" },
  { name: "United Kingdom", iso: "GB", cc: "44" },
  { name: "Uruguay", iso: "UY", cc: "598" },
  { name: "Uzbekistan", iso: "UZ", cc: "998" },
  { name: "Vanuatu", iso: "VU", cc: "678" },
  { name: "Venezuela", iso: "VE", cc: "58" },
  { name: "Vietnam", iso: "VN", cc: "84" },
  { name: "Virgin Islands (US)", iso: "VI", cc: "1340" },
  { name: "Yemen", iso: "YE", cc: "967" },
  { name: "Zambia", iso: "ZM", cc: "260" },
  { name: "Zimbabwe", iso: "ZW", cc: "263" },
];

export const findCountryByCc = (cc) => {
  const c = String(cc || "").replace(/\D/g, "");
  return COUNTRIES.find((x) => x.cc === c);
};
